const Services = () => {
  return (
    <section id="services" class="section">
      <div class="anchorref" id="2"></div>
      <div class="container">
        <h2 class="section-title">Our Products</h2>
        <div class="services-grid">
          <div class="service-item">
            <img
              class="foam"
              src="https://c3store.nyc3.digitaloceanspaces.com/mwpackaging/DSC02168.JPG"
              alt=""
            />
            <h3>Automotive Packs</h3>
            <p>
              Your go-to source for innovative automotive packaging solutions.
              Our specialty lies in class A surface protection for both
              expendable and returnable packaging, ensuring your products are
              kept safe and secure during transport. With our cutting-edge
              technology and expertise, we provide top-of-the-line packaging
              solutions for all your automotive needs.
            </p>
          </div>
          <div class="service-item">
            <img
              class="box"
              src="https://c3store.nyc3.digitaloceanspaces.com/mwpackaging/DSC02208.JPG"
              alt=""
            />
            <h3>Expendable Packaging</h3>
            <p>
              Our variety of materials and board grades allow us to provide
              solutions for all of your corrugated needs. From lightweight
              single-wall to heavy-duty double-wall, we ensure your packaging is
              design structural integrity to withstand stacking and shipping
              pressures. Turn your largest packaging component into your best
              marketing tool by adding custom printing to showcase your brand
              from the warehouse to your customer's doorstep.
            </p>
          </div>
          <div class="service-item">
            <img
              class="bag"
              src="https://c3store.nyc3.digitaloceanspaces.com/mwpackaging/DSC02172.JPG"
              alt=""
            />
            <h3>Dry Ice, Food and Pharmaceutical Packaging</h3>
            <p>
              Your one-stop solution for all your packaging needs. We offer a
              wide range of packaging solutions, including BOPP film, poly bags,
              poly liners, shrink wrap, dry ice, food storage and pharmaceutical
              packaging solutions. Our team of experts is dedicated to providing
              high-quality and cost-effective packaging options to meet your
              specific requirements. Trust us to provide top-notch packaging
              solutions that will keep your products safe and secure during
              transport and storage. Contact us today to learn more about our
              services.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
